/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import styled from 'styled-components'
import { useUsers } from 'querys/comments'

const ParticipantsStyled = styled.ul`
  background: var(--basePrimary);
  font: var(--p2Regular);

  position: fixed;
  top: var(--headerBlockSize);
  margin: 0;
  left: 16px;
  right: 16px;
  z-index: 10;

  .participant {
    border-bottom: 1px solid #ffffff40;
    padding: 6px 8px;
    display: flex;
    gap: 8px;
    align-items: center;
    img {
      border-radius: 50%;
    }
    &:last-of-type {
      border-bottom: none;
    }
  }
  @media (min-width: 768px) {
    position: static;
    margin-inline-start: 48px;
    .participant {
      padding: 2px 8px;
    }
  }
`

function Participants({
  comment, mention, arroba, participants: initialParticipants, setMention, setComment,
}) {
  const { data: participants } = useUsers({ initial: initialParticipants, arroba })

  if (!mention) return null

  const handlePartcipantClick = (name) => {
    const arrobaPosition = comment.lastIndexOf('@') + 1
    const commentWithMention = comment.slice(0, arrobaPosition) + name
    setMention(false)
    setComment(commentWithMention)
  }

  return (
    <ParticipantsStyled>
      {participants.filter(({ username }) => username.toLowerCase().startsWith(arroba.toLowerCase())).map(({ id, username, full_name, photo }) => (
        <li
          className={full_name.startsWith(arroba) ? 'participant is_active' : 'participant'}
          onClick={() => handlePartcipantClick(username)}
          key={id}
        >
          <img src={photo} alt={full_name} width="20" height="20" />
          {username}
        </li>
      ))}
    </ParticipantsStyled>
  )
}

export default Participants
